import { render, staticRenderFns } from "./ReportEvents.vue?vue&type=template&id=b421b784&scoped=true&"
import script from "./ReportEvents.vue?vue&type=script&lang=js&"
export * from "./ReportEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b421b784",
  null
  
)

export default component.exports